import { render, staticRenderFns } from "./ImportGenerals.vue?vue&type=template&id=25577b5e&"
import script from "./ImportGenerals.vue?vue&type=script&lang=ts&"
export * from "./ImportGenerals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports